import { Component, OnInit, Input } from '@angular/core';
import { tns, TinySliderInfo, TinySliderInstance } from '../../../../../node_modules/tiny-slider/src/tiny-slider';
import { ApiService } from '../../service/api.service';
import { AWS_IMAGE_URL } from '../../constants/constants';
import { UserService } from '../../service/user.service';
import { BevviAD, ADArray } from '../../interfaces/bevviad';

@Component({
  selector: 'bevvi-halfwidthad',
  templateUrl: './halfwidthad.component.html',
  styleUrls: ['./halfwidthad.component.scss']
})
export class HalfwidthadComponent implements OnInit {

  // BEVVI Banner Feature
  public canShow: boolean = false;
  public slider: (TinySliderInstance & {navPosition: string});
  public numOfBanner: number = 0;
  public adArray: Array<ADArray>
  public storeIndexTrack: Array<number> = [];
  public image_Url = AWS_IMAGE_URL;

  constructor(
    private apiService: ApiService,
    private userService: UserService
  ) { }

  ngOnInit() {

    this.apiService.getData(this.apiService.constants.GET_BEVVI_AD, {receipt: false}, true)
    .subscribe(
      (adResponse: BevviAD) => {
        console.log(adResponse);
        if (adResponse.showAds) {
          this.canShow = true;
          this.adArray = adResponse.productAdsArray;
          this.userService.adsActive(true);
          setTimeout(function() {
            this.slider = tns({
              container: '.my-slider',
              items: 5,
              slideBy: 'page',
              autoplay: true,
              gutter: 5,
              controls: false,
              nav: true,
              // navPosition: 'bottom',
              navAsThumbnails: true,
              arrowKeys: false,
              speed: 500,
              swipeAngle: false,
              autoWidth: true,
              fixedWidth: false,
              mouseDrag: true,
              loop: true,
              autoplayButton: false,
              // autoplayTimeout: 10000,
              autoplayButtonOutput: false,
              autoplayHoverPause: true,
              // lazyload: true,
              // responsive: {
              //   "1920": {
              //     fixedWidth: 1920
              //   },
              //   "1400": {
              //     fixedWidth: 1400
              //   },
              //   "1366": {
              //     fixedWidth: 1366
              //   },
              //   "1024": {
              //     fixedWidth: 1024,
              //   },
              //   "823": {
              //     fixedWidth: 823
              //   },
              //   "812": {
              //     fixedWidth: 812
              //   },
              //   "768": {
              //     fixedWidth: 768
              //   },
              //   "736": {
              //     fixedWidth: 736
              //   },
              //   "731": {
              //     fixedWidth: 731
              //   },
              //   "667": {
              //     fixedWidth: 667
              //   },
              //   "640": {
              //     fixedWidth: 640
              //   },
              //   "568": {
              //     fixedWidth: 568
              //   },
              //   "450": {
              //     fixedWidth: 450
              //   },
              //   "414": {
              //     fixedWidth: 414
              //   },
              //   "411": {
              //     fixedWidth: 411
              //   },
              //   "375": {
              //     fixedWidth: 375
              //   },
              //   "360": {
              //     fixedWidth: 360
              //   },
              //   "320": {
              //     fixedWidth: 320
              //   }
              // }
            });
          },200);
        } else {
          this.userService.adsActive(false);
          this.canShow = false;
        }
      }
    )
    
  }


}
